"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Sign Internal OpenAPI
 * Sign Internal OpenAPI spec
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TemplateGalleryListRequestToJSON = exports.TemplateGalleryListRequestFromJSONTyped = exports.TemplateGalleryListRequestFromJSON = exports.instanceOfTemplateGalleryListRequest = exports.attributeTypeMapTemplateGalleryListRequest = void 0;
exports.attributeTypeMapTemplateGalleryListRequest = [
    {
        name: "pageSize",
        type: "number",
    },
    {
        name: "pageNum",
        type: "number",
    },
    {
        name: "category",
        type: "string",
    },
    {
        name: "featured",
        type: "number",
    },
    {
        name: "sort",
        type: "string",
    },
    {
        name: "search",
        type: "string",
    },
];
/**
 * Check if a given object implements the TemplateGalleryListRequest interface.
 */
function instanceOfTemplateGalleryListRequest(value) {
    return true;
}
exports.instanceOfTemplateGalleryListRequest = instanceOfTemplateGalleryListRequest;
function TemplateGalleryListRequestFromJSON(json) {
    return TemplateGalleryListRequestFromJSONTyped(json, false);
}
exports.TemplateGalleryListRequestFromJSON = TemplateGalleryListRequestFromJSON;
function TemplateGalleryListRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        pageSize: json["page_size"] == null ? undefined : json["page_size"],
        pageNum: json["page_num"] == null ? undefined : json["page_num"],
        category: json["category"] == null ? undefined : json["category"],
        featured: json["featured"] == null ? undefined : json["featured"],
        sort: json["sort"] == null ? undefined : json["sort"],
        search: json["search"] == null ? undefined : json["search"],
    };
}
exports.TemplateGalleryListRequestFromJSONTyped = TemplateGalleryListRequestFromJSONTyped;
function TemplateGalleryListRequestToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        page_size: value["pageSize"],
        page_num: value["pageNum"],
        category: value["category"],
        featured: value["featured"],
        sort: value["sort"],
        search: value["search"],
    };
}
exports.TemplateGalleryListRequestToJSON = TemplateGalleryListRequestToJSON;
